var map = {
	"./pcBlack/introduceIcon1name.png": 4605,
	"./pcBlack/introduceIcon2name.png": 8766,
	"./pcBlack/introduceIcon3name.png": 2745,
	"./pcBlack/introduceIcon4name.png": 5103
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3074;